import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { MvcExceptionResponse } from '../mvc-exception-response';
import { catchError } from 'rxjs/operators';
import { HttpErrorService } from '../http-error.service';


@Injectable()
export class ErrorHandleInterceptor implements HttpInterceptor {
	constructor(
		protected errorService: HttpErrorService
	) {

	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next
			.handle(req)
			.pipe(
				catchError(error => this.handleError(error))
			);
	}

	protected handleError(error: any): Observable<any> {
		if (error instanceof HttpErrorResponse) {
			if (error.status === 406) {
				const erData: any = error.error;
				error = new MvcExceptionResponse(erData.type, erData.message)
			}
			else {
				this.errorService.emitError(error);
				console.error('An error occurred', error);
			}
		}

		return throwError(error);
	}
}